import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import Button from "./Button";
import { faTimes } from "@fortawesome/pro-regular-svg-icons";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { async } from "regenerator-runtime";
import { useTranslation } from "react-i18next";

const Email = ({ isOpen, onClose, emailButton, teamAction }) => {
  const { t } = useTranslation();
  const [memberEmailList, setMemberEmail] = useState([]);
  const [emailAddress, setEmailAddress] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [emailData, setEmailData] = useState({
    body: "",
    user_email: []
  });
  const [isOpen_inputWarning, setOpen_inputWarning] = useState(false);
  const [isAlert, setAlert] = useState("");

  const mailjet_api_base_url =
    window.themeObj.restURL + "/game/game-send-result-email";
  const addEmailText = window.end_page.end_send_email_add_button || "Add";

  const onInsertEmail = (e, emailAddress) => {
    e.preventDefault();

    const filterSameEmail = memberEmailList.find(item => item == emailAddress);

    if (emailAddress.trim().length === 0) {
      e.preventDefault();
      setOpen_inputWarning(true);
      setAlert("Cannot Input Empty Field");

      setTimeout(() => {
        setOpen_inputWarning(false);
      }, 2000);
    } else if (emailAddress !== filterSameEmail) {
      var email = [...memberEmailList];
      email.push(emailAddress);
      setMemberEmail(email);
      setDisabled(false);
    } else {
      setAlert("Sorry, you are not allowed to enter existing email");
      setOpen_inputWarning(true);

      setTimeout(() => {
        setOpen_inputWarning(false);
      }, 2000);
    }
    setEmailAddress("");
  };

  const deleteEmail = data => {
    var email = [...memberEmailList];

    for (var i = 0; i < email.length; i++) {
      if (email[i] === data) {
        email.splice(i, 1);
        setMemberEmail(email);
        break;
      }
    }

    if (email.length === 0) {
      setDisabled(true);
    }
  };

  const handleChange = e => {
    e.preventDefault();
    setEmailAddress(e.target.value);
  };

  const mailjet = axios.create({
    baseURL: mailjet_api_base_url
  });

  const sendMail = async () => {
    try {
      const emailDataClone = { ...emailData };
      const message = window.end_page.end_page_email_body;

      const body = `
     
      <br>
      <br>
      <br>
     ${message}
     <br>
     <br>
        ${teamAction
          .map(
            action => `
              - ${action} <br>
        `
          )
          .join("")}
          <br>
          <br>
      `;

      emailDataClone.user_email = [...emailData.user_email, ...memberEmailList];
      emailDataClone.body = body;

      const response = await mailjet.post("", emailDataClone);
    } catch (error) {
      console.error("");
    }

    onClose();
  };

  useEffect(() => {}, [emailData]);
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} className="email">
        <div className="email__wrapper">
          <div className="email__input">
            <input
              type="text"
              value={emailAddress}
              placeholder={t("Email Address")}
              onChange={handleChange}
            />
            <button
              type="submit"
              onClick={e => onInsertEmail(e, emailAddress)}
              className="email__add-button"
            >
              <FontAwesomeIcon icon={faPlus} />
              {addEmailText}
            </button>
          </div>
          <div
            className={isOpen_inputWarning ? `input-warning` : `close-warning`}
          >
            <p>{isAlert}</p>
          </div>

          <div className="email__list">
            {memberEmailList.map((item, index) => {
              return (
                <li className="email__item" key={index}>
                  <div className="content-text">
                    <span>{item}</span>
                  </div>
                  <button
                    className="delete-action"
                    onClick={() => deleteEmail(item)}
                    title={t("Delete")}
                  >
                    <FontAwesomeIcon className="trash-icon" icon={faTimes} />
                  </button>
                </li>
              );
            })}
          </div>
          <Button
            className="send-email"
            {...emailButton}
            disabled={disabled}
            onClick={sendMail}
          />
        </div>
      </Modal>
    </>
  );
};

export default Email;
